import FsLightbox from "fslightbox-react";
import React from "react";
import ProgressiveImage from 'react-progressive-image';

function Domain(props) {
  const { title, subtitle, imageUrl, largeImageUrl, url } = props.content;

  return (
    <div className="mi-portfolio mi-portfolio-visible">
      <div className="mi-portfolio-image">
        <ProgressiveImage
          src={imageUrl}
        >
          {src => <img src={src} alt={title} />}
        </ProgressiveImage>
      </div>
      {!url ? <h5>{title}</h5> : <h5>
        <a rel="noopener noreferrer" target="_blank" href={url}>
          {title}
        </a>
      </h5>}
      {subtitle ? <h6>{subtitle}</h6> : null}
      {!largeImageUrl ? null : <FsLightbox
        toggler={null}
        sources={largeImageUrl}
      />
      }
    </div>
  );
}

export default Domain;